export default "__VITE_PUBLIC_ASSET__31b7e20c__"